import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";

export default function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const strong = next.length >= 12 && /[a-z]/.test(next) && /[A-Z]/.test(next) && /\d/.test(next);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api("/admin/auth/change-password", { body: { current_password: cur, new_password: next } });
      toast.success("Password updated.");
      setOpen(false);
      setCur(""); setNext("");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="cw-soft h-9 rounded-lg px-2 text-sm hover:text-foreground" data-testid="admin-change-password-button">Password</button>
      </DialogTrigger>
      <DialogContent className="rounded-[20px]" data-testid="change-password-dialog">
        <form onSubmit={submit} className="space-y-5">
          <DialogHeader>
            <DialogTitle>Change password</DialogTitle>
            <DialogDescription>12+ characters with upper and lower case letters and a number.</DialogDescription>
          </DialogHeader>
          <div><Label htmlFor="cp-cur">Current password</Label>
            <Input id="cp-cur" type="password" autoComplete="current-password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-2" data-testid="change-password-current-input" /></div>
          <div><Label htmlFor="cp-new">New password</Label>
            <Input id="cp-new" type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-2" data-testid="change-password-new-input" />
            {next && !strong && <p className="cw-warning mt-2 text-xs">Not strong enough yet.</p>}</div>
          {error && <p className="cw-error text-sm" role="alert" data-testid="change-password-error">{error}</p>}
          <DialogFooter><Button type="submit" disabled={busy || !cur || !strong} data-testid="change-password-submit-button">{busy ? "Saving…" : "Update password"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
